import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  wrapper: {
    display: "flex",
    flex: 1,
    minHeight: "calc(100vh - 120px)",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  button: {
    margin: theme.spacing.unit
  }
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  handleBack = e => {
    e.preventDefault();
    this.setState({ hasError: false });
    this.props.history.goBack();
  };

  render() {
    const { classes } = this.props;

    if (this.state.hasError) {
      return (
        <div className={classes.wrapper}>
          <Typography variant="h5" gutterBottom>
            Something went wrong!
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            Please try again.
          </Typography>

          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleBack}
            className={classes.button}
          >
            Go Back
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default compose(
  withRouter,
  withStyles(styles)
)(ErrorBoundary);
